import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IApiResponse } from '@core/interfaces/api-response.interface';
import { ComponentStore } from '@ngrx/component-store';
import { ICreator, TCreatorApi } from '@pages/creators/creators.interface';
import { CreatorsService } from '@pages/creators/creators.service';
import { EMPTY, Observable } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';

interface ICtaAnalyticsDialogState {
  creators: ICreator[];
  loading: boolean;
  error: string | null;
}

const initialState: ICtaAnalyticsDialogState = {
  creators: [],
  error: null,
  loading: false,
};

@Injectable()
export class CtaAnalyticsDialogStore extends ComponentStore<ICtaAnalyticsDialogState> {
  public readonly creators$ = this.selectSignal((state: ICtaAnalyticsDialogState) => state.creators);
  public readonly loading$ = this.selectSignal((state: ICtaAnalyticsDialogState) => state.loading);
  public readonly error$ = this.selectSignal((state: ICtaAnalyticsDialogState) => state.error);

  public readonly fetchCreators = this.effect((trigger$: Observable<void>) => {
    return trigger$.pipe(
      tap(() => this.patchState({ error: null, loading: true })),
      switchMap(() =>
        this.creatorsService.getCreators(new HttpParams().set('limit', '1000').set('order_by', '-created_at')).pipe(
          tap((creators: IApiResponse<TCreatorApi[]>) => {
            this.patchState({ creators: creators?.data ?? [], loading: false });
          }),
          catchError(() => {
            this.patchState({
              error: 'Failed to load creators',
              loading: false,
            });

            return EMPTY;
          }),
        ),
      ),
    );
  });

  constructor(private readonly creatorsService: CreatorsService) {
    super(initialState);
  }
}
